export default __webpack_public_path__ + "static/media/portfolio image.a52a1b07.png";